<template>
  <section>
    <h2 class="heading-1">
      {{ i18n(translations.section1Title) }}
    </h2>
    <p class="text-static-default-low body-1 pt-8">
      {{ i18n(translations.section1Description) }}
    </p>

    <ComparisonArea
      :brand
      :category-id
      class="pt-32 text-center"
      variant="standard_vs_new"
    />

    <p class="body-2 my-32">
      {{ i18n(translations.section1Note) }}
    </p>
    <p v-if="link" class="body-2-bold my-32 text-center">
      <RevLink target="_blank" :to="link">
        {{ i18n(translations.section1Link) }}
      </RevLink>
    </p>
  </section>
  <RevDivider />
  <section class="mt-20">
    <h3 class="heading-3 py-24">
      {{ i18n(translations.section2Title) }}
    </h3>
    <BatteryFaq class="-mx-24" />
  </section>
</template>

<script lang="ts" setup>
import { useRouteLocationWithLocale } from '#imports'
import { computed } from 'vue'

import type { LinkInternal } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevDivider } from '@ds/components/Divider'
import { RevLink } from '@ds/components/Link'

import { LINKS } from '../../NewBatteryModal.constants'
import translations from '../../NewBatteryModal.translations'
import BatteryFaq from '../BatteryFaq/BatteryFaq.vue'
import ComparisonArea from '../ComparisonArea/ComparisonArea.vue'

defineProps<{
  brand: string
  categoryId: string
}>()

const i18n = useI18n()

const {
  market: { countryCode },
} = useMarketplace()

const resolveLocalizedRoute = useRouteLocationWithLocale()

const link = computed(() => {
  return LINKS[countryCode]
    ? resolveLocalizedRoute(LINKS[countryCode] as LinkInternal)
    : null
})
</script>
